import { coreService } from 'src/service/core-service'
import { queryKeys } from 'src/util/query-keys'
import { toasterUtil } from 'src/util/toaster-util'
import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query'

export const useDismissSuggestedSeries = (): UseMutationResult<void, Error, string> => {
  const queryClient = useQueryClient()

  return useMutation<void, Error, string>({
    mutationFn: (programmeId) => coreService.dismissSuggestedSeries(programmeId),
    onSuccess: (_, programmeId) => {
      queryClient.invalidateQueries(queryKeys.suggestedSeries())
      queryClient.invalidateQueries(queryKeys.myStartedProgrammes())
      queryClient.invalidateQueries({ queryKey: queryKeys.myStartedProgrammesFromLibraryPrefix() })
      queryClient.invalidateQueries(queryKeys.completedProgrammeWorkouts(programmeId))
    },
    onError: () => {
      toasterUtil.error('Failed to dismiss the series. Please try again.')
    },
  })
}
